import { FC } from 'react'
import { useQueryClient } from 'react-query'
import {
  IconPaths,
  ModalSize,
  QUERIES,
  showConfirmAlert,
  showError,
} from '../../../../../../../_metronic/helpers'
import { useT } from '../../../../../../../_metronic/i18n/Metronici18n'
import { RowActions, useModal, useToast } from '../../../../../../components'
import { NotaVersaoList } from '../../../core/_models'
import { deleteNotaVersao, getNotaVersaoById } from '../../../core/_requests'
import { useAbrirFormNotaVersao } from '../../../notas-versao-create/useAbrirFormNotaVersao'
import { NotaVersaoPreviaModal } from '../../components/NotaVersaoPreviaModal'

type Props = {
  nota: NotaVersaoList
}

export const NotasVersaoActionsCell: FC<Props> = ({ nota }) => {
  const { t } = useT()
  const { showModal } = useModal()
  const { showToast } = useToast()
  const queryClient = useQueryClient()
  const abrirForm = useAbrirFormNotaVersao()
  const nome = `${nota.titulo}, ${t('notas_versao.versao_x', { versao: nota.versao })}`

  const preVisualizar = () =>
    showModal({
      title: t('notas_versao.acao.pre_visualizar'),
      content: <NotaVersaoPreviaModal />,
      size: ModalSize.Large,
      fetchers: { nota: () => getNotaVersaoById(nota.id) },
    })

  const excluir = async () => {
    const confirmado = await showConfirmAlert({
      title: t('notas_versao.excluir.titulo', { versao: nota.versao }),
      text: t('notas_versao.excluir.texto'),
      confirmButtonText: t('notas_versao.excluir.confirmar'),
      cancelButtonText: t('notas_versao.excluir.cancelar'),
      danger: true,
      focusCancel: true,
    })
    if (!confirmado) return
    try {
      await deleteNotaVersao(nota.id)
      showToast({ variant: 'success', title: t('notas_versao.sucesso.excluida') })
      await queryClient.invalidateQueries(QUERIES.NOTAS_VERSAO_LIST)
    } catch (erro) {
      showError(erro)
    }
  }

  return (
    <RowActions
      itemName={nome}
      primaryAction={{
        label: t('notas_versao.acao.editar'),
        onClick: () => abrirForm(nota.id),
        icon: IconPaths.Pen,
      }}
      items={[
        { label: t('notas_versao.acao.pre_visualizar'), onClick: preVisualizar },
        { label: t('notas_versao.acao.excluir'), onClick: excluir, danger: true, divider: true },
      ]}
    />
  )
}
